cc.Class({
    extends: cc.Component,
    properties: {
        updateChildren: false
    },
    onLoad () {
        this.widget = this.node.getComponent(cc.Widget);
        if (this.updateChildren) {
            this.childrenWidgets = this.node.getComponentsInChildren(cc.Widget);
        }
    },
    onEnable () {
        this.widget.updateAlignment();
        if (this.updateChildren) {
            for(let i = 0; i < this.childrenWidgets.length; i++) {
                this.childrenWidgets[i].updateAlignment();
            }
        }
    }
});
